import { OrderStatus } from '@src/pages/Deliveries/context/orders';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIEText from '@src/shared/components/PIEText';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DASHBOARD_ORDER_FILTER_VALUES } from '../DashboardOrderListFilter';

interface componentProps {
  filterValue: DASHBOARD_ORDER_FILTER_VALUES;
}

export const DashboardEmptyFilteredOrderList = ({ filterValue }: componentProps) => {
  const { t } = useTranslation();
  const titles = {
    [DASHBOARD_ORDER_FILTER_VALUES.DELIVERED]: t('order.empty_filtered_order_list_delivered_title'),
    [DASHBOARD_ORDER_FILTER_VALUES.ON_THE_WAY]: t(
      'order.empty_filtered_order_list_indelivery_title'
    ),
    [DASHBOARD_ORDER_FILTER_VALUES.UNASSIGNED]: t(
      'order.empty_filtered_order_list_unassigned_title'
    ),
  };

  const messages = {
    [DASHBOARD_ORDER_FILTER_VALUES.DELIVERED]: t(
      'order.empty_filtered_order_list_delivered_description'
    ),
    [DASHBOARD_ORDER_FILTER_VALUES.ON_THE_WAY]: t(
      'courier_status_ontheway.ORDERS_ASSIGNED_TO_COURIERS'
    ),
    [DASHBOARD_ORDER_FILTER_VALUES.UNASSIGNED]: t(
      'order.empty_filtered_order_list_unassigned_description'
    ),
  };
  return (
    <PIEComponentUtil marginTop="var(--xds-spacing-c)">
      <PIEComponentUtil marginBottom={'var(--xds-spacing-b)'}>
        <PIEText
          size="var(--xds-font-size-16)"
          align="left"
          text={titles[filterValue]}
          fontWeight="var(--xds-font-weight-bold)"
        ></PIEText>
      </PIEComponentUtil>
      <PIEText
        size="var(--xds-font-size-14)"
        align="left"
        text={messages[filterValue]}
        fontWeight="var(--xds-font-weight-regular)"
      ></PIEText>
    </PIEComponentUtil>
  );
};

export default DashboardEmptyFilteredOrderList;
